import { Stack, Typography } from '@mui/material';
import { DefinitionList, designTokens } from '../../design-system';
import type { AbsenceTimeOffRequestCalculation } from './model';

type Limit = NonNullable<AbsenceTimeOffRequestCalculation['usageLimits']>[number];
const quantity = (value: string) => `${Number(value).toLocaleString('ko-KR', { maximumFractionDigits: 4 })}일`;
export const exceedsUsageLimit = (calculation?: AbsenceTimeOffRequestCalculation) => calculation?.usageLimits?.some((limit) => Number(limit.requestedQuantity) > Number(limit.availableQuantity)) ?? false;

export function AbsenceUsageLimitPreview({ limits }: { limits: readonly Limit[] }) {
  return <Stack component="section" aria-label="기간별 신청 가능량" spacing={1} role="status" aria-live="polite">
    {limits.map((limit) => {
      const excess = Number(limit.requestedQuantity) - Number(limit.availableQuantity);
      return <Stack key={`${limit.periodStart}:${limit.periodEnd}`} spacing={0.5}>
        <Typography variant="caption" color="text.secondary">{limit.periodStart} ~ {limit.periodEnd}</Typography>
        <Typography variant="body2">신청 가능 {quantity(limit.availableQuantity)} · 이번 신청 {quantity(limit.requestedQuantity)}{excess > 0 && <Typography component="span" variant="body2" sx={{ color: designTokens.color.dangerText, fontWeight: 600 }}> · {quantity(String(excess))} 초과</Typography>}</Typography>
      </Stack>;
    })}
  </Stack>;
}

export function AbsenceUsageLimitSummary({ limits, compact = false }: { limits: readonly Limit[]; compact?: boolean }) {
  return <Stack component="section" aria-label="기간별 사용 한도" spacing={1.5}>
    {limits.map((limit) => <Stack key={limit.periodStart} spacing={0.5}>
      <Typography variant="caption" color="text.secondary">{limit.periodStart} ~ {limit.periodEnd}</Typography>
      {compact ? <Typography variant="body2">한도 {quantity(limit.limitQuantity)} · 사용 {quantity(limit.usedQuantity)} · 승인 대기 {quantity(limit.pendingQuantity)} · 신청 가능 {quantity(limit.availableQuantity)}</Typography>
        : <DefinitionList items={[
          ['사용 한도', quantity(limit.limitQuantity)], ['사용 확정', quantity(limit.usedQuantity)], ['기존 승인 대기', quantity(limit.pendingQuantity)],
          ['추가 신청 가능', quantity(limit.availableQuantity)], ['이번 신청', quantity(limit.requestedQuantity)],
          ['신청 후 예상 가능', quantity(String(Math.max(0, Number(limit.availableQuantity) - Number(limit.requestedQuantity))))],
        ]} />}
    </Stack>)}
  </Stack>;
}
